import { api } from "jiffy-api";
import { hasConsentedToSocialMediaConversion } from "common/utils/ui/iub-consent-utils";
import { notifyError } from "common/utils/app-monitoring/notify";

const $getOrderNumber = () => document.querySelector(".js-order-number-container");

const sendServerSideConversion = async (eventName, data) => {
  if (!hasConsentedToSocialMediaConversion()) {
    return;
  }

  try {
    await api.product.sendSocialMediaConversionApi({
      event_id: data.event_id,
      order_number: $getOrderNumber()?.dataset?.orderNumber,
      event_name: eventName,
      source_url: window.location.href,
      value: data.event_value
    });
  } catch (error) {
    notifyError(`Error sending ${eventName} conversion event`, { context: { error } });
  }
};

export default sendServerSideConversion;
